var map = {
	"./aqua2.png": "71560",
	"./blue2.png": "1d33",
	"./indigo2.png": "d666",
	"./maroon2.png": "cd6f",
	"./orange2.png": "4c7e",
	"./pink2.png": "a037"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9b82";